export const MOTIVO_RECUSACION = 'RECUSACION';
export const MOTIVO_RECHAZO = 'RECHAZO';
export const MOTIVO_CANCELACION = 'CANCELACION';
export const MOTIVO_RESORTEO = 'RESORTEO';
export const MOTIVO_SUSPENSION = 'SUSPENSION';
